<template>
  <HomeLay>
    <div slot-scope="scope" class="me-body" :style="{ 'min-height': scope.data.height + 'px' }">
      <div class="margin-body">
        <div class="my-style">
          <div class="sidebar" v-loading="loading">
            <ul class="sidebar-menu">
              <li @click="turnTo(item.url)" v-for="(item,index) in menus" :key="index"><a href="#" :class="{active:item.active}"><i style="font-size: 20px;" :class="item.icon"></i> {{item.name}}</a></li>
            </ul>
          </div>
          <div class="main-content">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </HomeLay>
</template>

<script>
import HomeLay from '@/views/HomeLay/HomeLay.vue';

export default {
  components: {
    HomeLay
  },
  data() {
    return {
      title: '',
      NeedId: '',
      loading:false,
      url: {
        GetCustomAuthType: SZH.assets.api + '/Custom/GetCustomAuthType',
        menusUrl: SZH.assets.api + '/ClientsData/GetClientsDataJson',
        GetCompanyListInfo: SZH.assets.api + '/Custom/GetCompanyListInfo',
        GetTransportListInfo: SZH.assets.api + "/Custom/GetTransportListInfo",
      },
      menus:[],
      menusAll: [
        {
          name: '会员认证',
          url: '/My/MemberCenter',
          active: false,
          icon: 'el-icon-s-shop'
        },
        {
          name: '控制面板',
          url: '/My/ControlPanel',
          active: false,
          icon: 'el-icon-s-platform'
        },
        {
          name: '客户管理',
          url: '/My/Agent',
          active: false,
          icon: 'el-icon-user-solid'
        },
        {
          name: '案件管理',
          url: '/My/CaseManagement',
          active: false,
          icon: 'el-icon-s-finance'
        },
        {
          name: '我的发票',
          url: '/My/Invoice',
          active: false,
          icon: 'el-icon-s-ticket'
        },
        {
          name: '合同管理',
          url: '/My/ContractManagement',
          active: false,
          icon: 'el-icon-s-check'
        },
        {
          name: '佣金管理',
          url: '/My/CommissionManagement',
          active: false,
          icon: 'el-icon-bank-card'
        },
        {
          name: '推广管理',
          url: '/My/PromotionManagement',
          active: false,
          icon: 'el-icon-share'
        },
        {
          name: '子账号管理',
          url: '/My/SubAccountManagement',
          active: false,
          icon: 'el-icon-user'
        },
      ]
    }
  },
  methods: {
    turnTo(url) {
      this.$router.push({
        path: url
      })
    },
    setActiveItem(route) {
      // 根据路由路径设置activeItem
      const name = route.meta.name;
      this.menus.forEach(item=>{
        item.active = false;
        if(item.name == name){
          item.active = true;
        }
      })
    },
    getMenus(){
      let self = this;
      self.loading = true;
      self.menus = [];
      self.$http.post(self.url.menusUrl,{})
        .then(result => {
          if (result.state == true) {
            localStorage.setItem('pId',result.data.user.ParentUserId);

            localStorage.setItem('UserName',result.data.user.UserName);
            localStorage.setItem('PhoneNo',result.data.user.Phone);
            localStorage.setItem('RoleCode',result.data.user.RoleCode);

            let menus = JSON.parse(result.data.authorizeMenu);
            const filtered = self.menusAll.filter(item =>
              menus.some(filterItem => filterItem.F_FullName === item.name)
            );
            self.menus = filtered;
            let obj = {
              name: '个人中心',
              url: '/My/UserInfo',
              active: true,
              icon: 'el-icon-s-help'
            };
            self.menus.unshift(obj);
            self.loading = false;
            self.setActiveItem(this.$route);
          } else {
            self.menus = [];
            self.loading = false;
            self.$message.error(result.message);
          }
        }, () => {
          self.loading = false;
          // 请求失败
          self.$message.error('登录失败，请检查您的网络是否可用。');
        });
    },
  },
  computed: {}
  ,
  mounted() {

    this.getMenus()
  },
  watch: {
    '$route'(val) {
      this.setActiveItem(val)
    }
  }

}
</script>

<style scoped>
  .me-body{
    padding-top: 60px;
    padding-bottom: 20px;
  }
  .my-style{
    max-width: 1200px;
    margin: 60px auto 0px auto;
    padding: 0 20px;
    display: flex;
    gap: 30px;
  }
  /* 侧边栏 */
  .sidebar {
    width: 230px;
    flex-shrink: 0;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    padding: 20px 0;
    height: fit-content;
  }

  .sidebar-menu {
    list-style: none;
  }

  .sidebar-menu li {
    border-bottom: 1px solid #eee;
  }

  .sidebar-menu li:last-child {
    border-bottom: none;
  }

  .sidebar-menu a {
    display: flex;
    align-items: center;
    padding: 15px 25px;
    text-decoration: none;
    color: #333;
    transition: all 0.3s;
  }

  .sidebar-menu a:hover {
    background-color: #f5f7fa;
    color: #1a3a6c;
  }

  .sidebar-menu a.active {
    background-color: #f0f5ff;
    color: #1a3a6c;
    border-left: 4px solid #1a3a6c;
  }

  .sidebar-menu i {
    margin-right: 12px;
    width: 20px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/Me/LayOutTH/LayOutTH.vue